module.exports = __webpack_public_path__ + "img/privacy-icon.266585a5.svg";